import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CustomBtn from "components/fragments/CustomBtn";
import { numberWithTwoDecimals } from "utils/numberFormat";

export default function TransactionSuccessModal({
  selectedUserIdObj,
  modalOpenObj,
  startValueObj,
  isResetMoneyControllerObj,
  info,
  onClose,
  ...props
}) {
  const [value, setValue] = useState(startValueObj.startValue);
  const isWithdrawal = info.headModalTxt === "นำเงินออกสำเร็จ";

  useEffect(() => {
    if (modalOpenObj.modalOpen) {
      setValue(startValueObj.startValue);
      isResetMoneyControllerObj.setReset(true);
    }
  }, [modalOpenObj.modalOpen, startValueObj, isResetMoneyControllerObj]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={() => {
          modalOpenObj.setModalOpen(false);
          onClose();
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white w-[min(37.11vw,380px)] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-24 text-[var(--color-black-2)] text-center leading-[1.8] font-[500]">
            <div className="flex flex-col items-center text-18 font-[500]">
              <div className="font-[700] leading-[2.2]">
                {info.headModalTxt}
              </div>
              <div className="leading-[1.2] text-[var(--color-grey-2)] mt-[min(1.46vw,15px)]">
                เงินสด
              </div>
              <div
                className={`leading-[1.2] ${
                  isWithdrawal
                    ? "text-[var(--color-red)]"
                    : "text-[var(--color-green)]"
                }`}
              >
                {numberWithTwoDecimals(value)} บาท
              </div>
              <div className="mt-[min(2.44vw,25px)]">
                <CustomBtn
                  onClick={() => {
                    modalOpenObj.setModalOpen(false);
                    onClose();
                  }}
                  className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-white font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-main-active`}
                  btntxt={"ปิด"}
                />
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
